import {
  ArcElement,
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  Filler,
  Legend,
  LinearScale,
  LineElement,
  PointElement,
  RadialLinearScale,
  Title,
  Tooltip,
} from 'chart.js';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  LineElement,
  PointElement,
  ArcElement,
  Title,
  Tooltip,
  Legend,
  Filler,
  RadialLinearScale
);

// Initiative status colors
export const INITIATIVE_STATUS_COLORS = {
  completed: '#82C2A5',
  inProgress: '#F7A021',
  notStarted: '#27B0E0',
};

export const TASKS_COLORS = {
  completed: '#82C2A5',
  inProgress: '#F7A021',
  notStarted: '#27B0E0',
};

// Impacted people category colors
export const IMPACTED_PEOPLE_COLORS = {
  groups: '#c0d081',
  stakeholders: '#bfa1d7',
  employees: '#6f97d4',
  externals: '#f18a8a',
};

// Stakeholder support colors
export const STAKEHOLDER_SUPPORT_COLORS = {
  verySupportive: '#5daa7f',
  supportive: '#a8c97f',
  neutral: '#f6b93b',
  unsupportive: '#f7977a',
  veryUnsupportive: '#d55959',
};

// Chart colors
export const CHART_COLORS = {
  textMuted: '#7f8fa4',
  axisBorder: '#7f8fa4',
  axisBorderWidth: 1,
  tooltipBackground: 'rgba(0, 0, 0, 0.8)',
};

// Chart font settings
export const CHART_FONTS = {
  family: 'Nunito',
  size: {
    small: 10,
    regular: 12,
    medium: 14,
    large: 16,
  },
};

// Common font configurations
export const CHART_FONT_CONFIGS = {
  small: {
    size: CHART_FONTS.size.small,
    family: CHART_FONTS.family,
  },
  regular: {
    size: CHART_FONTS.size.regular,
    family: CHART_FONTS.family,
  },
  medium: {
    size: CHART_FONTS.size.medium,
    family: CHART_FONTS.family,
  },
  large: {
    size: CHART_FONTS.size.large,
    family: CHART_FONTS.family,
  },
  semibold: {
    size: CHART_FONTS.size.regular,
    family: CHART_FONTS.family,
    weight: 600,
  },
  mediumSemibold: {
    size: CHART_FONTS.size.medium,
    family: CHART_FONTS.family,
    weight: 600,
  },
};

// Centralized legend configuration
export const CHART_LEGEND_CONFIG = {
  display: true,
  position: 'bottom',
  align: 'center',
  labels: {
    usePointStyle: true,
    pointStyle: 'rect',
    padding: 20,
    font: CHART_FONT_CONFIGS.regular,
    color: CHART_COLORS.textMuted,
  },
  onHover: (event) => {
    event.native.target.style.cursor = 'pointer';
  },
  onLeave: (event) => {
    event.native.target.style.cursor = 'default';
  },
};

// Centralized tooltip configuration
export const CHART_TOOLTIP_CONFIG = {
  backgroundColor: '#ffffff',
  titleColor: '#153142',
  bodyColor: '#153142',
  borderColor: '#dfe2e5',
  borderWidth: 1,
  padding: 12,
  cornerRadius: 3,
  titleFont: CHART_FONT_CONFIGS.mediumSemibold,
  bodyFont: CHART_FONT_CONFIGS.semibold,
  displayColors: true,
  boxPadding: 6,
  boxWidth: 14,
  boxHeight: 14,
  usePointStyle: false,
  multiKeyBackground: 'transparent',
  callbacks: {
    labelColor: function (context) {
      const bgColor =
        context.dataset.backgroundColor instanceof Array
          ? context.dataset.backgroundColor[context.dataIndex]
          : context.dataset.backgroundColor;
      return {
        borderColor: 'rgba(0, 0, 0, 0)',
        backgroundColor: bgColor,
        borderWidth: 0,
      };
    },
  },
};

export default ChartJS;
